<template>
  <div class="d-flex align-center">
    <v-menu v-model="menu" offset-y rounded="0" transition="scale-transition" max-width="525">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon large v-bind="attrs" v-on="on">
          <v-icon dark>mdi-dots-grid</v-icon>
        </v-btn>
      </template>

      <v-card class="pa-4" color="surface" tile outlined>
        <div class="title mb-2">All Products</div>
        <v-row>
          <v-col v-for="(app, index) in applications" :key="index" cols="6" class="list-app" @click="openApp(app)">
            <v-card tile outlined icon hover ripple class="pa-4 d-flex align-center justify-start"
              style="width: 230px; height: 55px;">
              <v-img :src="`${config.auth_url}${app.svg}`" alt="svg" contain height="20" width="auto" />
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-menu>

    <v-img :src="`${config.auth_url}/api/services/assets/stream/app/svgs/ai.svg`" alt="svg" contain height="28"
      class="ml-2" width="auto" />
  </div>
</template>

<script>
import config from '@/config'
import axios from 'axios'

export default {
  data() {
    return {
      menu: false,
      applications: [],
    }
  },
  computed: {
    config() {
      return config
    },
  },
  methods: {
    openApp(app) {
      window.open(app.path, "_blank")
      this.menu = false
    },

    async fetchApps() {
      try {
        const response = await axios.get(`${this.config.auth_url}/api/services/assets/stream/configs/menu-apps.json`)
        this.applications = response.data.apps || []
      } catch (error) {
        console.error("Error fetching applications:", error)
        // fallback apps nếu cần
        this.applications = this.getFallbackApps()
      }
    },

    getFallbackApps() {
      return [
        { svg: '/api/services/assets/stream/app/light/browser.png', path: '/aetos-browser' },
        { svg: '/api/services/assets/stream/app/light/cube.png', path: '/aetos-cube' },
        { svg: '/api/services/assets/stream/app/light/ai.png', path: '/aetos-ai' },
        { svg: '/api/services/assets/stream/app/light/lab.png', path: '/aetos-lab' },
        { svg: '/api/services/assets/stream/app/light/canvas.png', path: '/aetos-canvas' },
        { svg: '/api/services/assets/stream/app/light/athena.png', path: '/athena' },
      ]
    },
  },
  mounted() {
    this.fetchApps()
  },
}
</script>

<style scoped>
.list-app {
  cursor: pointer;
  transition: transform 0.2s;
}

.list-app:hover {
  transform: scale(1.05);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/nav-menu.vue